import { BaseModel } from "../base.model";

export class kontniPlanDto extends BaseModel {
    konto: string;
    opis: string;
    subanalitika: boolean | null;
    konto_zatvaranja: string;
    status: number | null;
    konto_obrtnik: string;

    get subanalitikaFormated() {
        return (this.subanalitika == true) ? "DA" : "NE";
    }
}